import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/about.scss";

function About() {
  const essentials = [
    { label: "Shirts", image: "/main/about-shirts.jpg", to: "/shop?category=Shirts" },
    { label: "Knitwear", image: "/main/about-knitwear.jpg", to: "/shop?category=Knitwear" },
    { label: "Shoes", image: "/main/about-shoes.jpg", to: "/shop?category=Shoes" },
  ];

  return (
    <main className="about-page">
      <header className="about-hero">
        <div className="about-hero__copy">
          <p className="eyebrow">WHO ARE WE?</p>
          <h1>Rooted in calm.<br />Made to endure.</h1>
          <p>{siteConfig.description}</p>
        </div>
        <img src="/main/about-atelier.jpg" alt="A craftsperson fitting a tailored jacket in the atelier" />
      </header>

      <section className="about-intro section-pad">
        <p className="eyebrow">OUR STORY</p>
        <h2>Clothes are at their best when they become part of your story.</h2>
        <div>
          <p>
            We began with a simple idea: create a complete menswear wardrobe without noise or excess.
            Familiar pieces, redrawn with the right proportions, expressive cloth and an easy, natural character.
          </p>
          <p>
            Each edition adds a small new chapter while the foundations remain. We make, undo and remake until
            a garment feels natural from the very first wear—and even better after the hundredth.
          </p>
        </div>
      </section>

      <section className="about-craft" id="craft">
        <img src="/main/about-craft.jpg" alt="Hands measuring an olive wool jacket" loading="lazy" />
        <div>
          <p className="eyebrow">SAVOIR-FAIRE</p>
          <h2>The patience of a good piece</h2>
          <p>
            Our partner ateliers are specialists: shirtmakers, knitters, tailors and leather workers whose
            knowledge lives in practiced hands. We choose them for precision, curiosity and respect for the
            people who make every piece.
          </p>
          <ul>
            <li>Natural and certified materials wherever possible</li>
            <li>Long-term partnerships with specialist European ateliers</li>
            <li>Construction designed to be worn, cared for and repaired</li>
          </ul>
        </div>
      </section>

      <section className="about-values section-pad">
        <article><span>01</span><h3>Better materials</h3><p>We select fibers for their beauty, traceability and ability to endure everyday life.</p></article>
        <article><span>02</span><h3>Right proportions</h3><p>Our fits are refined over time, balancing comfort with a clean, lasting silhouette.</p></article>
        <article><span>03</span><h3>Fewer, considered pieces</h3><p>We prefer a focused wardrobe that works together over a collection made for a moment.</p></article>
      </section>

      <section className="about-essentials section-pad">
        <div className="section-heading section-heading--center"><div><p className="eyebrow">OUR FOUNDATIONS</p><h2>The essentials</h2></div></div>
        <div className="about-essentials__grid">
          {essentials.map((item) => (
            <Link key={item.label} to={item.to}>
              <img src={item.image} alt="" loading="lazy" />
              <span>{item.label}</span>
            </Link>
          ))}
        </div>
      </section>

      <section className="about-closing">
        <p className="eyebrow">THE WARDROBE CONTINUES</p>
        <h2>Made for now.<br />Kept for later.</h2>
        <Link className="button button--light" to="/shop">Explore the collection</Link>
      </section>
    </main>
  );
}

export default About;
